export default __webpack_public_path__ + "static/media/bank_bbl.88f3b91e.svg";